import { useCallback, useEffect, useState } from 'react'
import { League } from 'types/leagues'
import { useParams } from 'react-router-dom'
import { getLeagueById } from 'services/leagues'
import { getLeaguesScoreTable } from 'services/games'
import { LeagueScoreTable } from '../../../components/league-score-table'
import { Score } from 'types/games'

export const ScoreTable = () => {
    const { league: leagueId } = useParams()

    const [league, setLeague] = useState<League>()
    const [scoreTable, setScoreTable] = useState<Score[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const getLeagueInfo = useCallback(() => {
        setLoading(true)
        getLeagueById(Number(leagueId))
            .then(setLeague)
            .finally(() => {
                setLoading(false)
            })
    }, [leagueId])

    const getScoreTableData = useCallback(() => {
        getLeaguesScoreTable(Number(leagueId)).then(setScoreTable)
    }, [leagueId])

    useEffect(() => {
        getLeagueInfo()
        getScoreTableData()
    }, [getLeagueInfo, getScoreTableData])

    return (
        <div>
            League: {league?.name}
            <LeagueScoreTable data={scoreTable} loading={loading} />
        </div>
    )
}
